import styled from "styled-components";

export const DetalharPessoasWrapper = styled.div`
    display: flex;
    justify-content: center;
`;